import { createFileRoute, redirect } from '@tanstack/react-router';

import { isTenantAdmin, useTenantStore } from '@/auth/tenantStore';
import { ErrorComponent } from '@/components/common/ErrorComponent';
import { useSetBreadcrumbs } from '@/components/layout/breadcrumbs';

import { ExternalLinksPage } from './-components/ExternalLinksPage';

function ExternalLinksRoute() {
  useSetBreadcrumbs([{ label: 'Settings' }, { label: 'External links' }]);
  return <ExternalLinksPage />;
}

export const Route = createFileRoute('/settings/external-links')({
  beforeLoad: () => {
    if (!isTenantAdmin(useTenantStore.getState())) {
      throw redirect({ to: '/contacts', search: { page: 0, pageSize: 25 } });
    }
  },
  component: ExternalLinksRoute,
  errorComponent: ErrorComponent,
});
